import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CityService } from '../../../shared/_services/city.service';
import { City, MissingData } from '../../../shared/models/missingdata.model';
import { Departaments } from '../../../shared/models/missingdata.model';
import { FileService } from '../../../shared/_services/file.service';

@Component({
  selector: 'app-fill-cities',
  templateUrl: './fill-cities.component.html',
  styleUrls: ['./fill-cities.component.css']
})
export class FillCitiesComponent implements OnInit {

  cityList: City[];
  departments: Departaments[];
  btnText: string;

  constructor(
    private cityService: CityService,
    private fileService: FileService,
    private router: Router
  ){}

  ngOnInit() {
    this.fileService.getMissingData()
      .subscribe((res: MissingData) => {
        this.cityList = res.listMissingCities as City[];
        if (this.cityList === null || this.cityList.length < 1) {
          this.router.navigate(['/manage-file/fill-offices']);
        } else {
          this.cityService.getdepartments()
            .subscribe(departments => { this.departments = departments });
          this.btnText = this.fileService.checkStep(1,res) ? 'Siguiente' : 'Finalizar'
        }
      },error => {
        console.log(error)
        this.router.navigate(['/']);
      });
  }

  onSubmit() {
    this.cityService.saveCities(this.cityList)
      .subscribe((res: any) => { console.log(res) }, err => console.log(err));
    //console.log(this.cityList);
    this.router.navigate(['/manage-file/fill-offices']);
  }

}
